// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBFa1_a8WEgpn8mRh1HUFihyxH8QTcFk3Y",
  authDomain: "lisssts.firebaseapp.com",
  databaseURL: "https://lisssts-default-rtdb.firebaseio.com",
  projectId: "lisssts",
  storageBucket: "lisssts.appspot.com",
  messagingSenderId: "57881228526",
  appId: "1:57881228526:web:8db750cb09a9f318adefff",
  measurementId: "G-KC22HHKJN9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);

// Set up Google Auth Provider
const googleProvider = new GoogleAuthProvider();

export { auth, database, googleProvider };